import { schema } from "normalizr";

import { Entity } from "@/mk2/schemas";

export interface LikeableEntity extends Entity {
    isLiked: boolean;
    likesCount: number;
    entity?: string;
}

export interface EmojiLikeableEntity extends LikeableEntity {
    userReaction: string | null;
    reactionsBreakdown: Record<string, number>;
    reactionsTotalCount: number;
}

export const likeKey = (entity: string, id: number): string => `${entity}/${id}`;

export const createLikeableSchema = (entity) =>
    new schema.Entity(
        "likeable",
        {},
        {
            idAttribute: (value, parent, key) => likeKey(entity, value.id || parent.id),
            processStrategy: (value, parent, key) => ({ ...value, id: parent.id, entity }),
        },
    );

export const createEmojiLikeableSchema = (entity) =>
    new schema.Entity(
        "likeable",
        {},
        {
            idAttribute: (value, parent, key) => likeKey(entity, value.id || parent.id),
            processStrategy: (value, parent, key) => ({
                ...value,
                id: parent.id,
                entity,
                // Prefer value fields (from emojilikeable_to_json_for_export), fall back to parent top-level fields
                userReaction:
                    value.userReaction !== undefined
                        ? value.userReaction
                        : parent.userReaction !== undefined
                          ? parent.userReaction
                          : null,
                reactionsBreakdown: value.reactionsBreakdown || parent.reactionsBreakdown || {},
                reactionsTotalCount: value.reactionsTotalCount || parent.reactionsTotalCount || 0,
            }),
        },
    );
